import { Cookie } from 'frontcore/domain/cookies/types'

export default class CookieRepository {

  get (key: string) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${key}=`)
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift()
    }
    return undefined
  }

  set (cookie: Cookie) {
    let cookieToAdd = `${cookie.key}=${cookie.value};`
    if (cookie.isSecure) {
      cookieToAdd += ' Secure;'
    }
    if (cookie.maxAge) {
      cookieToAdd += ` max-age=${cookie.maxAge};`
    }
    if (cookie.sameSite) {
      cookieToAdd += ` SameSite=${cookie.sameSite};`
    }
    if (cookie.path) {
      cookieToAdd += ` Path=${cookie.path}`
    }
    document.cookie = cookieToAdd
  }

  delete (key: string) {
    const voidCookie = {
      key,
      value: '',
      maxAge: -1,
    }

    this.set(voidCookie)
  }
}
